import TheGrid from '@/views/dealers/dealers/grid'
import Edit from '@/views/dealers/dealers/edit'

export default {
  path: '/dealers/dealers',
  redirect: '/dealers/dealers/index',
  name: 'dealers',
  meta: {
    auth: {
      redirect: {
        name: 'dealers.index'
      },
      forbiddenRedirect: '/dashboard'
    },
    label: 'Distribuidores'
  },
  component: {
    render(c) {
      return c('router-view')
    }
  },
  children: [{
    path: 'index',
    name: 'dealers.index',
    component: TheGrid,
    meta: {
      auth: true,
      label: 'Lista'
    }
  }, {
    path: 'create',
    name: 'dealers.create',
    component: Edit,
    meta: {
      auth: true,
      label: 'Criar'
    }
  }, {
    path: 'edit/:id',
    name: 'dealers.edit',
    component: Edit,
    meta: {
      auth: true,
      label: 'Editar'
    }
  }]
}
